import { ReactSVG } from "react-svg";
import UploadSvg from "../../../../assets/upload.svg";
import { useEffect, useMemo, useState } from "react";
import { useWatch } from "react-hook-form";
import { ModalNotaFornecedor } from "../../../Modal/NotaFiscalFornecedor";

export const LinhaPropostaFornecedor = ({
    quantidade,
    indexQuantidade,
    filterOrcamentos,
    dataAtual,
    prazoMaximoDeProposta,
    admin,
    register,
    setValue,
    control,
    watch,
    reset
}) => {
    const orcamento = useMemo(
        () => filterOrcamentos?.find(elem => elem.quantidade === quantidade),
        [filterOrcamentos, quantidade]
    );

    useEffect(() => {
        reset({
            [`participar_${quantidade}`]: orcamento?.status === "Não Participa" ? true : false,
            [`valor_unitario_${quantidade}`]: orcamento?.valor_unidade || null,
            [`valor_total_${quantidade}`]: orcamento?.valor_total || null,
            [`prazo_${quantidade}`]: orcamento?.prazo_producao || null,
            [`nf_fornecedor_${quantidade}`]: null
        })
    }, [orcamento])

    const orcamentoExists = Boolean(orcamento);

    // Assiste o valor do input de arquivo
    const arquivo = useWatch({
        control,
        name: `nf_fornecedor_${quantidade}`,
    });

    const handleRemoveUpload = () => {
        setValue(`nf_fornecedor_${quantidade}`, null);
        const input = document.getElementById(`nf_fornecedor_${indexQuantidade}`);
        if (input) input.value = "";
    };

    const renderInput = ({
        name,
        type = "text",
        placeholder = "",
        defaultValue = "",
        disabled = false,
        step,
        onChange
    }) => (
        <input
            {...register(name, { onChange })}
            type={type}
            placeholder={placeholder}
            defaultValue={defaultValue}
            disabled={disabled}
            step={step}
            id="numeroFloat"
        />
    );

    return (
        <tr>
            <td className="quantidade h5">{quantidade} unidades</td>

            <td className="participar">
                <input
                    type="checkbox"
                    className="check"

                    {...register(`participar_${quantidade}`)}
                    defaultChecked={orcamento?.status == "Não Participa"}
                    disabled={dataAtual > prazoMaximoDeProposta || (orcamentoExists && !admin)}
                />
            </td>

            <td>
                {renderInput({
                    name: `valor_unitario_${quantidade}`,
                    placeholder: "R$ 00,00",
                    defaultValue: orcamento?.valor_unidade,
                    disabled: !admin && orcamentoExists,
                    type: "number",
                    step: 0.0001,
                    onChange: (e) =>
                        setValue(`valor_total_${quantidade}`, Number(e.target.value) * quantidade)
                })}
            </td>

            <td className="valor-total">
                {renderInput({
                    name: `valor_total_${quantidade}`,
                    placeholder: "R$ 00,00",
                    defaultValue: orcamento?.valor_total,
                    disabled: true,
                    type: "number",
                    step: 0.0001
                })}
            </td>

            <td className="prazo">
                {renderInput({
                    name: `prazo_${quantidade}`,
                    placeholder: "00 dias",
                    defaultValue: orcamento?.prazo_producao,
                    disabled: !admin && orcamentoExists,
                    type: "number"
                })}
            </td>

            <td className="status">
                <div className="input-container div-upload">
                    {orcamentoExists && admin ? "" : (orcamento && orcamento.nf_fornecedor ?
                        <div className="upload">
                            <a href={orcamento.nf_fornecedor} target="_blank">
                                Anexo
                            </a>
                        </div>
                        :
                        <label htmlFor={`nf_fornecedor_${indexQuantidade}`}>
                            <ReactSVG src={UploadSvg} />
                        </label>)
                    }
                    {arquivo?.[0] ? (
                        <div className="upload">
                            <a
                                href={
                                    orcamento?.nf_fornecedor instanceof File
                                        ? URL.createObjectURL(orcamento.nf_fornecedor)
                                        : orcamento?.nf_fornecedor
                                }
                                target="_blank"
                            >
                                Anexo
                            </a>
                            <span
                                className="delete-upload"
                                onClick={handleRemoveUpload}
                            >
                                X
                            </span>
                        </div>
                    ) : (
                        <h4></h4>
                    )}
                    <input
                        disabled={!admin && orcamentoExists}
                        type="file"
                        id={`nf_fornecedor_${indexQuantidade}`}
                        {...register(`nf_fornecedor_${quantidade}`)}
                    />
                </div>
            </td>
            <td className="status">
                {orcamentoExists && <h4>{orcamento.status}</h4>}
            </td>
        </tr>
    );
};